export default __webpack_public_path__ + "b1dfedc4e997541c5d20b357bd56e9d6.svg";